import React, { useEffect, useState, useMemo } from "react";
import { Switch, NavLink } from "react-router-dom";
import PrivateRoute from "@common/components/route/PrivateRoute";
import { useSmartFitnessContext } from "@icoach/smartFitnessBand/components/SmartFitnessContext";
import SmartFitnessBandContractDetailSummaryPanel from "@icoach/smartFitnessBand/contract/SmartFitnessBandContractDetailSummaryPanel";
import SmartFitnessBandContractDetailOrderMainPanel from "@icoach/smartFitnessBand/contract/SmartFitnessBandContractDetailOrderMainPanel";
import SmartFitnessBandContractDetailOrderHistoryPanel from "@icoach/smartFitnessBand/contract/SmartFitnessBandContractDetailOrderHistoryPanel";
import useDeviceOrderApi from "@apis/useDeviceOrderApi";
import NavigationTabsLayout from "@icoach/components/navigationTabs/NavigationTabsLayout";
import { CLUB_MEMBERS_ROUTER } from "@icoach/router/routerPath";

const SmartFitnessBandContractDetail = React.forwardRef((props, ref) => {
	const [isMounted, setMounted] = useState(false);
	const { deviceOrderID, setDetailSourceData } = useSmartFitnessContext();
	const { getDeviceOrderDetailInfoApi } = useDeviceOrderApi();

	const getInitDetailApi = async contracID => {
		const resp = await getDeviceOrderDetailInfoApi(contracID);
		if (resp) {
			setDetailSourceData(resp);
			setMounted(true);
		}
	};

	const tabData = useMemo(
		() => {
			return [
				{
					label: "訂閱主檔",
					value: "MAIN",
					component: NavLink,
					to: CLUB_MEMBERS_ROUTER.SMARTFITNESSBAND.CONTRACT_DETAIL_MAIN_PATH(deviceOrderID),
				},
				{
					label: "訂閱歷史",
					value: "HISTORY",
					component: NavLink,
					to: CLUB_MEMBERS_ROUTER.SMARTFITNESSBAND.CONTRACT_DETAIL_HISTORY_PATH(deviceOrderID),
				},
			];
		},
		// eslint-disable-next-line
		[deviceOrderID]
	);

	useEffect(
		() => {
			if (!deviceOrderID) {
				return;
			} else {
				getInitDetailApi(deviceOrderID);
			}
		},
		// eslint-disable-next-line
		[deviceOrderID]
	);

	return (
		<React.Fragment>
			{isMounted && (
				<React.Fragment>
					<SmartFitnessBandContractDetailSummaryPanel />
					<NavigationTabsLayout tabs={tabData} tabsContent={{ className: "py-3 px-4" }}>
						<Switch>
							<PrivateRoute exact path={CLUB_MEMBERS_ROUTER.SMARTFITNESSBAND.CONTRACT_DETAIL_MAIN_PAGE} as={SmartFitnessBandContractDetailOrderMainPanel} />
							<PrivateRoute exact path={CLUB_MEMBERS_ROUTER.SMARTFITNESSBAND.CONTRACT_DETAIL_HISTORY_PAGE} as={SmartFitnessBandContractDetailOrderHistoryPanel} />
						</Switch>
					</NavigationTabsLayout>
				</React.Fragment>
			)}
		</React.Fragment>
	);
});

export default SmartFitnessBandContractDetail;
